<template>
    <div class="area-trends">
        <VillagesTopNav @leftIconFun="leftIconFun">
            <div slot="content" @click="areaSelect">
                <h2>安阳<img class="qiehuan-img" src="../../assets/img/icon/dizhiqiehuan.png" alt="" srcset=""></h2>
            </div>
        </VillagesTopNav>
        <van-popup v-model="show" position="top" round>
            <VillagesTopNav @leftIconFun="show=false">
                <div slot="content" @click="areaSelect" >
                    <h2>安阳<img class="qiehuan-img" src="../../assets/img/icon/dizhiqiehuan.png" alt="" srcset=""></h2>
                </div>
            </VillagesTopNav>
            <div class="search-border">
                <van-search
                    shape="round"
                    placeholder="搜索"
                    />
            </div>
            <div class="adress-gps van-hairline--bottom">
                <img class="gps" src="../../assets/img/icon/gps.png" alt="">
                <span class="aress-location">北京市</span>
                <span class="aress-livver">GPS定位</span>
            </div>
            <div class="adress-list van-hairline--bottom">
                <p class="adress-list-title">已选择</p>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
                <div class="adress-item" >
                    北京
                </div>
            </div>
            <div class="adress-select-btn">
                <div class="cancel-btn van-hairline--surround" @click="show=false">
                    取消
                </div>
                <div class="query-btn">
                    确定
                </div>
            </div>
        </van-popup>
        <van-tabs>
            <van-tab title="地区动态">
                <areaTrendsDetails></areaTrendsDetails>
            </van-tab>
            <van-tab title="附近商铺">
                <nerbyShops></nerbyShops>
            </van-tab>
            <van-tab title="本地论坛">
                <LocalForum></LocalForum>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
    import areaTrendsDetails from './AreaTrendsDetails.vue'
    import nerbyShops from './NerbyShops.vue'
    import LocalForum from './LocalForum.vue'
    import VillagesTopNav from '../../components/VillagesTopNav.vue'
    export default {
        data() {
            return {
                location: "",
                show:false
            }
        },
        mounted() {
            // console.log(this.$wx);
            // let self = this;
            // this.$wx.config({
            //     debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            //     appId: 'wx8abdc34b7f9bf939', // 必填，公众号的唯一标识
            //     timestamp: 1584805780144, // 必填，生成签名的时间戳
            //     nonceStr: '4242', // 必填，生成签名的随机串
            //     signature: '0eff726c8b9dc22066dd56b795cbe2f970b76943',// 必填，签名
            //     jsApiList: [
            //     "getLocation",
            //     ] // 必填，需要使用的JS接口列表
            // });
            // this.$wx.ready(function () {
            //     self.$wx.getLocation({
            //         type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            //         success: function (res) {
            //             this.location = JSON.stringify(res);
            //             console.log(res);
            //         }
            //     });
            // });

        },
        methods:{
            areaSelect(){
                this.show = true;
            },
            leftIconFun(){
                this.$router.go(-1);
            }
        },
        components: {
            areaTrendsDetails,
            nerbyShops,
            LocalForum,
            VillagesTopNav
        }
    }
</script>
<style scoped>
    .adress-select-btn{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .adress-select-btn>div{
        width:294px;
        height:67px;
        display: flex;
        background:rgba(255,255,255,1);
        border-radius:34px;
        justify-content: center;
        align-items: center;
        font-size:24px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(52,52,52,1);
        line-height:33px;
        margin: 40px 13px;
    }
    .adress-select-btn>div.cancel-btn{
        border:1px solid rgba(148,148,148,1);
    }
    .adress-select-btn>div.query-btn{
        background:linear-gradient(90deg,rgba(242,23,12,1) 0%,rgba(242,76,11,1) 100%);
        color: #fff;
    }
    .area-trends h2{
        font-size:28px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
    }
    .adress-list{
        width: 680px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #F7F7F7;
        flex-wrap: wrap;
        padding-bottom: 10px;
        border-bottom: solid 4px #F2F2F2;
    }
    .adress-item{
        width:152px;
        height:54px;
        background:rgba(245,245,245,1);
        border-radius:27px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size:24px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(52,52,52,1);
        line-height:33px;
        margin-bottom: 30px;
        margin-right: 20px;
    }
    .adress-item:nth-child(4n + 5){
        margin-right: 0;
    }
    .adress-list-title{
        font-size:26px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(4,4,4,1);
        line-height:37px;
        margin: 16px 0 25px 0;
        width: 100%;
    }
    .adress-gps{
        width: 680px;
        margin: 0 auto;
        padding: 28px 0 27px 0;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #F7F7F7;
    }
    .adress-gps .gps{
        width: 19px;
        height: 25px;
    }
    .adress-gps .aress-location{
        font-size:26px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(52,52,52,1);
        line-height:37px;
        display: inline-block;
        margin: 0 20px 0 8px;
    }
    .adress-gps .aress-livver{
        font-size:26px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:#BFBFBF;
        line-height:37px;
    }
    .area-trends {
        background-color: #FFFFFF;
    }
    .search-border{
        border-bottom: solid 10px #F7F7F7;
    }
    .area-trends .van-tabs__wrap {
        height: 110px;
        border-bottom: 20px solid #f5f5f5;
        box-sizing: border-box;
    }

    .area-trends .van-tab--active {
        color: #FF1919;
    }
    .qiehuan-img{
        width: 26px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        position: relative;
        top: -3px;
    }
    .area-trends .van-tab--active .van-tab__text {
        font-size: 30px;
    }

    .area-trends .van-tabs__nav .van-tab__text {
        font-size: 28px;
        line-height: 90px;
        font-family: pingFangSC-Medium;
    }

    .area-trends .van-tabs__nav .van-tabs__line {
        width: 48px !important;
        height: 6px !important;
        background: linear-gradient(to right, #F00F00, #FF9176, #FFDDD4);
    }
</style>